/*
 * Copyright (c) Nexign, JSC, 2019-2025.
 */
/**
 * Styled components for TableFooter
 *
 * @author Yakov Gushchin
 * @author Aleksandr Perkhunov
 * @author Anton Panasenko
 * @author Evgenij Tyan
 * @author Nikolay Sviridov
 * @version 1.36.0
 * @since 1.0.0
 */
import styled from 'styled-components';

import { colors, fonts, globalThemeConstants } from '../../../../theme';
import { FlexStyled } from '../../Block/Flexbox';

export interface ITableContainerProps {
    maxWidth?: number;
}

export const TableFooterFastActionsButtonsStyled = styled.div.attrs({
    className: 'subscriber-mobile__fast-actions-buttons',
})`
    display: flex;
    flex-direction: row;
    align-items: center;
    gap: 24px;
`;

export const TableFooterContainerStyled = styled.div`
    position: relative;
    display: flex;
    justify-content: space-between;
    max-width: ${globalThemeConstants.maxSiteWidth};
    margin: 0 auto;
    padding: 0 50px;
    box-sizing: border-box;

    /* special style for personal account page*/
    &.personal-account-footer .table-footer__right-container {
        display: flex;
        align-items: flex-start;
        flex-grow: 1;
    }
`;
export const TableFooterButtonContainerStyled = styled(FlexStyled).attrs({
    className: 'table-footer__btn-container',
})`
    justify-content: space-between;
    width: 100%;
`;
export const TableFooterLeftContainerStyled = styled.div<ITableContainerProps>`
    display: flex;
    flex-wrap: wrap;
    flex-direction: row;
    padding: 8px 0;
    box-sizing: border-box;
    max-width: ${(props) => props.maxWidth ? props.maxWidth + 'px' : 'none'};
`;

export const TableFooterRowContainerStyled = styled.div`
    display: flex;
`;

export const TableFooterRightContainerStyled = styled.div<ITableContainerProps>`
    display: flex;
    flex-wrap: wrap;
    flex-direction: column;
    justify-content: flex-start;
    padding: 8px 0;
    max-width: ${(props) => props.maxWidth ? props.maxWidth + 'px' : 'none'};
`;


export const TableFooterCounterContainerStyled = styled.div`
    position: absolute;
    top: -62px;
    left: 40px;
    z-index: 50;
`;

export const TableFooterOpenHandlerStyled = styled.div`
    position: absolute;
    top: -62px;
    display: flex;
    align-items: center;
    justify-content: center;
    line-height: 1;
    padding: 6px 12px;
    border-radius: 18px;
    box-sizing: border-box;
    background: ${colors.tableFooterButtonBg};
    cursor: pointer;
    ${fonts.textSmall};
    color: ${colors.tableFooterButtonTextColor};
    &:hover {
        background: ${colors.tableFooterButtonBgHover};
    }
    & .block-with-icon .block-with-icon__icon-right {
        transform: rotate(180deg);
    }

    &.open {
        padding: 6px;
        border-radius: 100%;
        & .block-with-icon .block-with-icon__icon-right {
            transform: initial;
        }
    }
`;

export const TableFooterShowMenuStyled = styled.span`
    ${fonts.textSmall};
    color: ${colors.tableFooterButtonTextColor};
    margin-right: 4px;
`;
